import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreInitiativesFilesByIdDeleteAsyncSlice } from './delete';
import { coreInitiativesFilesByIdPatchAsyncSlice } from './patch';

export const coreInitiativesFilesByIdReducers = combineReducers({
	delete: coreInitiativesFilesByIdDeleteAsyncSlice.asyncReducers,
	patch: coreInitiativesFilesByIdPatchAsyncSlice.asyncReducers
});

export const coreInitiativesFilesByIdWatchers = combineAllWatchers([
	coreInitiativesFilesByIdDeleteAsyncSlice.asyncWatchers,
	coreInitiativesFilesByIdPatchAsyncSlice.asyncWatchers
]);
